export default "__VITE_ASSET__CtA4gC14__"